var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.componentName,_vm._b({tag:"component",on:{"initData":function (data) { return _vm.$emit('initData', data); },"input":_vm.input,"change":_vm.change,"clear":_vm.clear},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var item = ref.item;
return [_vm._t("default",null,{"item":item})]}}],null,true)},'component',_vm.$props,false))}
var staticRenderFns = []

export { render, staticRenderFns }